import buildSelectMenuDefinition, {
    SelectMenuDefinition
} from "../../../../../../../utils/forms/models/grid-fields/select-menu-definition";
import buildSwitchDefinition, {
    SwitchDefinition
} from "../../../../../../../utils/forms/models/grid-fields/switch-definition";
import {FormDefinition} from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildButtonSelectorDefinition, {
    ButtonSelectorDefinition
} from "../../../../../../../utils/forms/models/grid-fields/button-selector-definition";
import buildNumberInputDefinition, {
    NumberInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/number-input-definition";
import buildTextInputDefinition
    , {TextInputDefinition} from "../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import {boolean} from "yup";
import buildBulletsSelectorDefinition, {
    BulletsSelectorDefinition
} from "../../../../../../../utils/forms/models/grid-fields/bullets-selector-definition";
import buildGroupDefinition, {
    GroupDefinition
} from "../../../../../../../utils/forms/models/grid-fields/group-definition";

export enum SCHEMA_NAMES {
    SYSTEM = "system",
    SAS_AS_REPORT_SYSTEM = "sas_as_report_system",
    SAS_CONTROL_BILL_ACCEPTOR = "sas_control_bill_acceptor",
    VOUCHER_DIGITS = "voucher_digits",
    PROVIDER = "provider",
    USE_PROMO_CREDITS = "use_promo_credits",
    USE_4_DIGIT_GISTRA = "use_4_digit_gistra",
    EXPIRATION_TIME = "expiration_time",
    EXPIRATION_TYPE = "expiration_type",
    AUTO_HANDPAY_CLOSE = "auto_handpay_close",
    PRINT_CASHOUT_TICKET = "print_cashout_ticket",
    HAS_PREFIX_CODE = "has_prefix_code",
    PREFIX_CODE = "prefix_code",
    ACCEPTED_COINS = "accepted_coins",
    ACCEPTED_BILLS = "accepted_bills",
    COIN_BILL_ACCEPTOR_GROUP = "coin_bill_acceptor_group",
    EXTERNAL_PROVIDER = "external_provider"
}

export const ACCOUNTING_SYSTEM_DICT = [
    {label: "SAS", value: 0},
    {label: "S2S", value: 1},
    {label: "TITO", value: 2},
    {label: "APOSTOU", value: 3}
];

const filterSystems = schemaSystem => {
    return ACCOUNTING_SYSTEM_DICT.filter(system => {
        return schemaSystem.includes(system.value);
    });
};

export const ACCOUNTING_SYSTEM = (
    system_enum: number[] | null,
    hasTITOSystem: boolean | null
): ButtonSelectorDefinition => {
    const items = system_enum && system_enum.length > 0
        ? filterSystems(system_enum)
        : ACCOUNTING_SYSTEM_DICT
    if (!hasTITOSystem && items.find(i => i.value === 2)) {
        items.splice(items.findIndex(i => i.value === 2), 1)
    }
    return buildButtonSelectorDefinition({
        name: "system",
        id: "AccountingConfigAccountingSystem",
        label: "Accounting System",
        items: items,
        schemaName: SCHEMA_NAMES.SYSTEM,
        exclusive: true,
        fieldOverrides: {
            columnClass: "col-12 button-selector",
            formSpacing: false
        }
    });
};

export const ACCEPTED_COINS = (
    items: { label: string | number; value: string | number }[]
): BulletsSelectorDefinition => {
    return buildBulletsSelectorDefinition({
        name: "accepted_coins",
        id: "accepted_coins",
        label: "Accepted Coins",
        items: items,
        completeList: items,
        schemaName: SCHEMA_NAMES.ACCEPTED_COINS,
        fieldOverrides: {
            formSpacing: true,
            multipleSelection: true,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });
}

export const ACCEPTED_BILLS = (
    items: { label: string | number; value: string | number }[]
): BulletsSelectorDefinition => {
    return buildBulletsSelectorDefinition({
        name: "accepted_bills",
        id: "accepted_bills",
        label: "Accepted Bills",
        items: items,
        completeList: items,
        schemaName: SCHEMA_NAMES.ACCEPTED_BILLS,
        fieldOverrides: {
            formSpacing: false,
            multipleSelection: true,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });
}

export const COIN_BILL_ACCEPTOR_GROUP: GroupDefinition = buildGroupDefinition({
    label: "Coin/Bill Acceptor",
    id: "coin_bill_acceptor_group",
    name: "coin_bill_acceptor_group"
});

const SAS_AS_REPORTING_SYSTEM: SwitchDefinition = buildSwitchDefinition({
    name: "sas_as_report_system",
    id: "SASAsReportSystem",
    label: "SAS As Report System",
    schemaName: SCHEMA_NAMES.SAS_AS_REPORT_SYSTEM
});

const SAS_CONTROL_BILL_ACCEPT: SwitchDefinition = buildSwitchDefinition({
    name: "sas_control_bill_acceptor",
    id: "SASControllBillAcceptor",
    label: "SAS Controll Bill Acceptor",
    schemaName: SCHEMA_NAMES.SAS_CONTROL_BILL_ACCEPTOR
});

export const VOUCHER_DIGITS_DICT = [
    {
        label: "4 Digit Ticket Voucher",
        value: 4
    },
    {
        label: "18 Digit Ticket Voucher",
        value: 18
    }
];

export const VOUCHER_DIGITS_AMYC_DICT = [
    {
        label: "13 Digit Ticket Voucher",
        value: 13
    }
];

const VOUCHER_DIGITS: SelectMenuDefinition = buildSelectMenuDefinition({
    id: "VoucherDigits",
    name: "voucher_digits",
    noValueLabel: "Select an option...",
    label: "Voucher Type",
    items: VOUCHER_DIGITS_DICT,
    schemaName: SCHEMA_NAMES.VOUCHER_DIGITS
});

export const EXPIRATION_TYPE_DICT = [
    {label: "By Hours", value: 0},
    {label: "By Days", value: 1},
    {
        label: "By Turn of Day",
        value: 2
    },
    {label: "By Session", value: 3}
];

export const EXPIRATION_TYPE_GISTRA_DICT = [
    {label: "By Hours", value: 0},
    {label: "By Days", value: 1},
    {
        label: "By Turn of Day",
        value: 2
    }
];

export const EXPIRATION_TYPE_AMYC_DICT = [
    {label: "By Days", value: 1}
];

const EXPIRATION_TYPE: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "expiration_type",
    id: "SettingsConfigExpirationType",
    noValueLabel: "Select an option...",
    label: "Expiration Type",
    items: EXPIRATION_TYPE_DICT,
    schemaName: SCHEMA_NAMES.EXPIRATION_TYPE
});

const EXPIRATION_TIME: NumberInputDefinition = buildNumberInputDefinition({
    name: "expiration_time",
    id: "SettingsExpriationTime",
    placeholder: "Expiration Time",
    label: "Expiration Time",
    schemaName: SCHEMA_NAMES.EXPIRATION_TIME
});

const AUTO_HANDPAY_CLOSE: SwitchDefinition = buildSwitchDefinition({
    name: "auto_handpay_close",
    id: "CloseCashOut",
    label: "Automatic Handpay Closing",
    schemaName: SCHEMA_NAMES.AUTO_HANDPAY_CLOSE
});

const PRINT_CASHOUT_TICKET: SwitchDefinition = buildSwitchDefinition({
    name: "print_cashout_ticket",
    id: "PrintCashoutTicket",
    label: "Print Cashout Ticket on Server",
    schemaName: SCHEMA_NAMES.PRINT_CASHOUT_TICKET
});

export const PROVIDER_DICT = [
    {value: 0, label: "Caliente"},
    {value: 1, label: "CIE"},
    {value: 2, label: "PLAYTRAK"},
    {value: 3, label: "SASIView30"},
    {value: 4, label: "PINFBM7Digit"},
    {value: 5, label: "SASWinSystems"},
    {value: 6, label: "S2SWinSystems"},
    {value: 7, label: "SASSACATR"},
    {value: 8, label: "SASIView20Bally"},
    {value: 9, label: "S2SAlesis"},
    {value: 10, label: "S2SGlobalGamingSystems"},
    {value: 11, label: "SASGlobalGamingSystems"},
    {value: 12, label: "SASeWese"},
    {value: 13, label: "SASAceSystems"},
    {value: 14, label: "SASBINSUR"},
    {value: 15, label: "SASPROMOS"},
    {value: 16, label: "SASAxesSystems"},
    {value: 17, label: "S2CSAC"},
    {value: 18, label: "SASGIC"},
    {value: 19, label: "PlayCity"},
    {value: 20, label: "SASDRGT"},
    {value: 21, label: "SASLogrand"},
    {value: 22, label: "WinSystem"},
    {value: 23, label: "PlayTech"},
    {value: 24, label: "SASGAMA"},
    {value: 25, label: "TITO FBM"},
    {value: 26, label: "TITOVALID4"},
    {value: 27, label: "IPS"},
    {value: 28, label: "FutureGamingSystems"},
    {value: 29, label: "AxesNetwork"},
    {value: 30, label: "Gistra"},
    {value: 31, label: "Cirsa"},
    {value: 32, label: "Intimus"},
    {value: 33, label: "AMYC"},
    {value: 34, label: "COLIMEX"}
];

const EXTERNAL_PROVIDER_DICT = [
    {value: null, label: "No External Provider"},
    ...PROVIDER_DICT

];

export const SAS_PROVIDER: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "provider",
    id: "sas_provider",
    label: "SAS Provider",
    noValueLabel: "Select an option...",
    items: PROVIDER_DICT,
    schemaName: SCHEMA_NAMES.PROVIDER,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
    }
});

export const S2S_PROVIDER: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "provider",
    id: "s2s_provider",
    label: "S2S Provider",
    noValueLabel: "Select an option...",
    items: PROVIDER_DICT,
    schemaName: SCHEMA_NAMES.PROVIDER,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
    }
});

export const TITO_PROVIDER: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "provider",
    id: "tito_provider",
    label: "Provider",
    noValueLabel: "Select an option...",
    items: PROVIDER_DICT,
    schemaName: SCHEMA_NAMES.PROVIDER,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
    }
});

export const APOSTOU_PROVIDER: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "provider",
    id: "apostou_provider",
    label: "Provider",
    noValueLabel: "Select an option...",
    items: PROVIDER_DICT,
    schemaName: SCHEMA_NAMES.PROVIDER,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
    }
});

const USE_4_DIGIT_GISTRA: SwitchDefinition = buildSwitchDefinition({
    name: "use_4_digit_gistra",
    id: "use_4_digit_gistra",
    label: "4 Digit Gistra",
    schemaName: SCHEMA_NAMES.USE_4_DIGIT_GISTRA
});

const USE_PROMO_CREDITS: SwitchDefinition = buildSwitchDefinition({
    name: "usePromoCredits",
    id: "usePromoCredits",
    label: "Use Promo Credits",
    schemaName: SCHEMA_NAMES.USE_PROMO_CREDITS
});

const HAS_PREFIX_CODE: SwitchDefinition = buildSwitchDefinition({
    name: "has_prefix_code",
    id: "has_prefix_code",
    label: "Configure Prefix Code",
    schemaName: SCHEMA_NAMES.HAS_PREFIX_CODE
});

const PREFIX_CODE: TextInputDefinition = buildTextInputDefinition({
    name: "prefix_code",
    id: "prefix_code",
    placeholder: "Prefix Code",
    label: "Prefix Code",
    schemaName: SCHEMA_NAMES.PREFIX_CODE
});

const EXTERNAL_PROVIDER: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "external_provider",
    id: "external_provider",
    label: "External Provider",
    noValueLabel: "No External Provider",
    items: EXTERNAL_PROVIDER_DICT,
    schemaName: SCHEMA_NAMES.EXTERNAL_PROVIDER,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
    }
});

export const ACCOUNTING_FORM_DEFINITION: (
    currentSelectedSystem: number | null,
    expiration: number,
    provider: number | null,
    voucher: number | null,
    system_enum: number[] | null,
    hasPrefixCode: boolean | null,
    accepted_coins: { label: string | number; value: string | number }[] | null,
    accepted_bills: { label: string | number; value: string | number }[] | null,
    productionServer: boolean | null
) => FormDefinition = (
    currentSelectedSystem,
    expiration,
    provider,
    voucher,
    system_enum,
    hasPrefixCode,
    accepted_coins,
    accepted_bills,
    hasTITOSystem
) => {
    let systemSpecificProvider: ButtonSelectorDefinition;
    let expiration_type = EXPIRATION_TYPE_DICT;
    let voucher_digits = VOUCHER_DIGITS_DICT;

    if (currentSelectedSystem === 0) {
        systemSpecificProvider = SAS_PROVIDER;
    } else if (currentSelectedSystem === 1) {
        systemSpecificProvider = S2S_PROVIDER;
    } else if (currentSelectedSystem === 2) {
        systemSpecificProvider = TITO_PROVIDER;
    } else if (currentSelectedSystem === 3) {
        systemSpecificProvider = APOSTOU_PROVIDER;
    }

    if (provider == 30 || provider == 32) expiration_type = EXPIRATION_TYPE_GISTRA_DICT;
    else if (provider == 33) {
        expiration_type = EXPIRATION_TYPE_AMYC_DICT;
        voucher_digits = VOUCHER_DIGITS_AMYC_DICT;
    }

    if (currentSelectedSystem === null) {
        return {
            [SCHEMA_NAMES.SYSTEM]: {
                definition: ACCOUNTING_SYSTEM(system_enum, hasTITOSystem),
                order: 0
            },
            [SCHEMA_NAMES.ACCEPTED_COINS]: {
                definition: {
                    ...ACCEPTED_COINS(accepted_coins)
                },
                order: 12
            },
            [SCHEMA_NAMES.ACCEPTED_BILLS]: {
                definition: {
                    ...ACCEPTED_BILLS(accepted_bills)
                },
                order: 13
            },
            [SCHEMA_NAMES.COIN_BILL_ACCEPTOR_GROUP]: {
                definition: {...COIN_BILL_ACCEPTOR_GROUP},
                order: 11
            }
        };
    }

    let fields = {
        [SCHEMA_NAMES.SYSTEM]: {
            definition: {
                ...ACCOUNTING_SYSTEM(system_enum, hasTITOSystem)
            },
            order: 0
        },
        [SCHEMA_NAMES.PROVIDER]: {
            definition: systemSpecificProvider,
            order: 1
        },
        [SCHEMA_NAMES.USE_PROMO_CREDITS]: {
            definition: {
                ...USE_PROMO_CREDITS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.EXPIRATION_TYPE]: {
            definition: {
                ...EXPIRATION_TYPE,
                items: expiration_type,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 time"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.SAS_AS_REPORT_SYSTEM]: {
            definition: {
                ...SAS_AS_REPORTING_SYSTEM,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 hidden"
                }
            },
            order: 4
        },
        [SCHEMA_NAMES.SAS_CONTROL_BILL_ACCEPTOR]: {
            definition: {
                ...SAS_CONTROL_BILL_ACCEPT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 5
        },
        [SCHEMA_NAMES.COIN_BILL_ACCEPTOR_GROUP]: {
            definition: {...COIN_BILL_ACCEPTOR_GROUP},
            order: 11
        },
        [SCHEMA_NAMES.ACCEPTED_COINS]: {
            definition: {
                ...ACCEPTED_COINS(accepted_coins)
            },
            order: 12
        },
        [SCHEMA_NAMES.ACCEPTED_BILLS]: {
            definition: {
                ...ACCEPTED_BILLS(accepted_bills)
            },
            order: 13
        }

    };

    if (currentSelectedSystem === 2 && (provider === 31 || provider === 25)) {
        fields[SCHEMA_NAMES.AUTO_HANDPAY_CLOSE] = {
            definition: {
                ...AUTO_HANDPAY_CLOSE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 8
        }
    }

    if (
        (currentSelectedSystem !== null && currentSelectedSystem !== 2) ||
        (currentSelectedSystem === 2 && provider != 30 && provider != 32)
    ) {
        fields[SCHEMA_NAMES.VOUCHER_DIGITS] = {
            definition: {
                ...VOUCHER_DIGITS,
                items: voucher_digits,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
                }
            },
            order: 6
        };
    }

    if (expiration == 0 || expiration == 1 || expiration == null) {
        fields[SCHEMA_NAMES.EXPIRATION_TIME] = {
            definition: {
                ...EXPIRATION_TIME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 time"
                }
            },
            order: 2
        };
    }

    if ((voucher == 4 && provider != 30) || (voucher == 4 && provider != 32)) {
        fields[SCHEMA_NAMES.USE_4_DIGIT_GISTRA] = {
            definition: {
                ...USE_4_DIGIT_GISTRA,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 7
        };
    }
    if (voucher == 4) {
        fields[SCHEMA_NAMES.PRINT_CASHOUT_TICKET] = {
            definition: {
                ...PRINT_CASHOUT_TICKET,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 9
        };
    }
    if (voucher == 18 && provider == 25) {
        fields[SCHEMA_NAMES.HAS_PREFIX_CODE] = {
            definition: {
                ...HAS_PREFIX_CODE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 9
        };
    }
    if (hasPrefixCode) {
        fields[SCHEMA_NAMES.PREFIX_CODE] = {
            definition: {
                ...PREFIX_CODE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 10
        };
    }
    if (voucher == 4 && provider == 25) {
        fields[SCHEMA_NAMES.EXTERNAL_PROVIDER] = {
            definition: EXTERNAL_PROVIDER,
            order: 10
        };
    }

    return fields;
};

export const ACCOUNTING_FIELD_NAMES = {
    [SCHEMA_NAMES.SYSTEM]: "Accounting System",
    [SCHEMA_NAMES.SAS_AS_REPORT_SYSTEM]: "SAS As Report System",
    [SCHEMA_NAMES.SAS_CONTROL_BILL_ACCEPTOR]: "SAS Controll Bill Acceptor",
    [SCHEMA_NAMES.VOUCHER_DIGITS]: "Voucher Type",
    [SCHEMA_NAMES.PROVIDER]: "Provider",
    usePromoCredits: "Use Promo Credits",
    [SCHEMA_NAMES.USE_4_DIGIT_GISTRA]: "4 Digit Gistra",
    [SCHEMA_NAMES.EXPIRATION_TIME]: "Expiration Time",
    [SCHEMA_NAMES.EXPIRATION_TYPE]: "Expiration Type",
    [SCHEMA_NAMES.ACCEPTED_COINS]: "Accepted Coins",
    [SCHEMA_NAMES.ACCEPTED_BILLS]: "Accepted Bills"
};
